import { merchantApi } from '@/config/axios'

export interface O2oPricingMerchantPageReqVO {
  pageNo: number
  pageSize: number
  serviceId?: number
  status?: string
}

export interface O2oPricingMerchantRespVO {
  id: number
  serviceId: number
  serviceName?: string
  categoryId?: number
  categoryName?: string
  basePrice?: number
  applyPrice?: number
  floatRatio?: number
  status?: string
  rejectReason?: string
  auditTime?: string
  effectiveTime?: string
  remark?: string
  createTime?: string
}

export interface O2oPricingServiceOptionVO {
  serviceId: number
  serviceName?: string
  categoryId?: number
  categoryName?: string
  basePrice?: number
  effectivePrice?: number
  minApplyPrice?: number
  maxApplyPrice?: number
  latestApplyStatus?: string
}

export interface O2oPricingApplyReqVO {
  serviceId: number
  applyPrice: number
  remark?: string
}

export function getO2oMerchantPricingPage(params: O2oPricingMerchantPageReqVO) {
  return merchantApi.get<{ list: O2oPricingMerchantRespVO[]; total: number }>({
    url: '/merchant-api/o2o/pricing/page',
    params
  })
}

export function getO2oMerchantPricingServiceOptions() {
  return merchantApi.get<O2oPricingServiceOptionVO[]>({
    url: '/merchant-api/o2o/pricing/service-options'
  })
}

export function applyO2oMerchantPricing(data: O2oPricingApplyReqVO) {
  return merchantApi.post<number>({
    url: '/merchant-api/o2o/pricing/apply',
    data
  })
}
